module.exports = __webpack_public_path__ + "img/65ne.39a972ca.svg";